import { render, staticRenderFns } from "./ShippingOrderModal.vue?vue&type=template&id=66ed93bd&scoped=true"
import script from "./ShippingOrderModal.vue?vue&type=script&lang=js"
export * from "./ShippingOrderModal.vue?vue&type=script&lang=js"
import style0 from "./ShippingOrderModal.vue?vue&type=style&index=0&id=66ed93bd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66ed93bd",
  null
  
)

export default component.exports